var version = {
    "name":      "dativery",
    "buildDateCode": "20260805-084359",
    "buildDate": "Wed Aug 05 2026 08:43:59 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260805-084359",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;